import { render, staticRenderFns } from "./FinanceWalletsAggregationModal.vue?vue&type=template&id=379c1498&scoped=true&"
import script from "./FinanceWalletsAggregationModal.vue?vue&type=script&lang=js&"
export * from "./FinanceWalletsAggregationModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "379c1498",
  null
  
)

export default component.exports